
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增隐患问题
export function addHiddenDanger(params) {
    return post(`${HOST}hidden-danger-rectification/save`, params)
}
// 修改隐患问题
export function updateHiddenDanger(params) {
    return post(`${HOST}hidden-danger-rectification/update`, params)
}
//隐患问题列表
export function getHiddenDanger(params) {
    return get(`${HOST}hidden-danger-rectification/hiddenDangerRectificationList`, params)
}
//隐患问题详情
export function HiddenDangerDetial(params) {
    return get(`${HOST}hidden-danger-rectification/get/${params}`)
}
// 删除隐患问题
export function delHiddenDanger(params) {
    return post(`${HOST}hidden-danger-rectification/delete/${params}`)
}
// 隐患问题历史修改版本列表
export function getHistoryList(params) {
    return get(`${HOST}hidden-danger-rectification-history/list`, params)
}
// 历史修改版本详情
export function getHistoryDetial(params) {
    return get(`${HOST}hidden-danger-rectification-history/get`, params)
}







// WEBPACK FOOTER //
// ./src/views/PotentialSafetyHazard/api/api.js